import styled, { css } from "styled-components";
import { ResetButton } from "../../../atoms/Button/Button.styles";


export const MenuItemIconWrapper = styled.div`
  width: ${({ theme }) => theme.rem(24)};
  height: ${({ theme }) => theme.rem(24)};
  border-radius: 50%;
  background-color: lightgreen;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: ${({ theme }) => theme.rem(16)};
  top: 50%;
  transform: translateY(-50%);
  transition: background-color 0.2s ease-out 0s;
`

export const MenuItem = styled(ResetButton)`
  min-height: ${({ theme }) => theme.rem(56)};
  margin-bottom: ${({ theme }) => theme.rem(8)};
  padding: ${({ theme }) => theme.rem(16, 40, 16, 16)}!important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  gap: ${({ theme }) => theme.rem(4)};
  border-radius: ${({ theme }) => theme.rem(8)};
  transition: background-color 0.2s ease-out 0s, border-color 0.2s ease-out 0s;
  color: ${({ theme }) => theme.colorScheme['header'].button.secondary.textDefault};
  background-color: transparent;
  border: 1px solid #EEE;

  ${({ theme }) => theme.mediaQuery.lg(`
    margin-bottom: ${theme.rem(16)}!important;
  `)}

  ${({ theme }) => theme.mediaQuery.xl(`
    min-height: ${theme.rem(0)};
    margin-bottom: ${theme.rem(0)}!important;

    &:not(:last-child) {
      margin-bottom: ${theme.rem(16)}!important;
    }
    
    &:hover {
      background-color: lightgreen;
      border-color: lightgreen;

      ${MenuItemIconWrapper} {
        background-color: #FFF;
      }
    }
  `)}
`